import { $fetch, $post, $put, $delete } from '@/services/axios';

export function validate(data) {
  return $post(`company/lp/product/validate`, data);
}

export function add(data) {
  return $put(`company/lp/product`, data);
}

export function fetch(data) {
  return $fetch(`company/lp/${data.lpId}/products`);
}

export function sort(lpId, data) {
  return $post(`company/lp/${lpId}/products/sort`, data);
}

export function edit(data) {
  return $post(`company/lp/product/${data.id}`, data);
}

export function remove(data) {
  return $delete(`company/lp/product/${data.id}/${data.version}`);
}
